<script>
	module.exports = {
		modelData: {
			toolsTab: 'toolsTab'
		},
		components: {
			'tab-container': require('components/tab-container.vue').default,
			'my-list': require('components/routes/my-tools/my-list.vue').default,
			basecamp: require('components/routes/my-tools/basecamp.vue').default
		}
	};
</script>
<style lang="scss">
	.my-tools {
		.main-header {
			padding-bottom: 0;
		}
	}
</style>
<template>
	<main class="main my-tools">
		<header class="main-header">
			<div class="wrapper">
				<h1 class="main-header-title">My Tools</h1>
				<tab-container
					model-key="toolsTab"
					:default-tab="'list'">
					<button data-tab="list">My List</button>
					<button data-tab="basecamp">My How-tos</button>
				</tab-container>
			</div>
		</header>
		<my-list
			v-if="toolsTab === 'list'"
			ref="toolsTabPanel"
			data-panel="list"></my-list>
		<basecamp
			v-if="toolsTab === 'basecamp'"
			ref="toolsTabPanel"
			data-panel="basecamp"></basecamp>
	</main>
</template>
